// extracted by mini-css-extract-plugin
module.exports = {"root":"VbZbhAV","searchAgain":"_2ovygTE"};
    if(module.hot) {
      // 1545369452761
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  